import moment from "moment";
import React, { useEffect, useState } from "react";

export default function Time() {
  const [time, setTime] = useState(moment());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(moment());
    }, 1000);
    return () => {
      clearInterval(timer); // Return a funtion to clear the timer so that it will stop being called on unmount
    };
  }, []);

  return (
    <div className="large marginleft" >
      {moment(time).format("DD-MM-YYYY HH:mm:ss")}
    </div>
  );
}